import { EMAIL_REGEX } from './otherRecipients';

export const SENDER_FIELD_MAX_LENGTH = 250;

export const REPLY_TO_ERROR_MESSAGE = 'Reply-To Email must be a valid email address.';

// Default sender details stored on a template; absent values become empty strings so the inputs stay controlled.
export const getSenderFields = (template) => ({
    fromName: template?.fromName || '',
    replyToEmail: template?.replyToEmail || '',
});

// The API clears a stored value when it is omitted or blank, so both fields are always sent (trimmed).
export const getSenderPayload = ({ fromName = '', replyToEmail = '' } = {}) => ({
    fromName: fromName.trim(),
    replyToEmail: replyToEmail.trim(),
});

export const isInvalidReplyToEmail = (value = '') => {
    const trimmed = value.trim();
    return trimmed !== '' && !EMAIL_REGEX.test(trimmed);
};
